import moreRequestData from './moreRequestData';
import WIS from './WIS';

const root = {
	moreRequestData,
	WIS
};

export default root;
